// extracted by mini-css-extract-plugin
export default {"basic-table":"BasicDataTable_basic-table__w37lv","label-typography":"BasicDataTable_label-typography__7WA08","value-typography":"BasicDataTable_value-typography__z4MYc"};